import { AppRouteProps } from "@mzara/component";
import { MindMapDangerZoneContainer } from "./containers/MindMapDangerZoneContainer";

export const MindMapDetailsDangerRoutes: Array<AppRouteProps> = [
    {
        path: 'danger',
        element: <MindMapDangerZoneContainer />
    }
]